import { EVENT_SPECIAL_PARAMS_FOR_UPDATE } from '@/modules/Events/constants';
import { apiDirectoryService, apiService } from '@/services/APIService';

export default {
  authCentrifuge(params) {
    return apiService.post('/auth/centrifuge', params);
  },

  getPublicEvents(params) {
    return apiService.get('/public/events', params);
  },

  getPublicEventsCached(params) {
    return apiService.getCached('/public/events', params);
  },

  getEvents(params) {
    return apiService.get('/events', params);
  },

  getEventsCached(params) {
    return apiService.getCached('/events', params);
  },

  getOrganizationEvents(params) {
    return apiService.get('/events/for-organization', params);
  },

  getOrganizersRootEvent(eventId, munId, params) {
    return apiService.get(`/organizers/root-event/${eventId}/${munId}`, params);
  },

  searchEvents(params) {
    return apiService.get('/public/events/search2', params);
  },

  // EVENT
  getReady(id, params) {
    return apiService.get(`/events/${id}/ready`, params);
  },

  getPdf(id, params) {
    return apiService.post(`/events/${id}/memo`, params);
  },

  getEvent(id, params) {
    return apiService.get(`/events/${id}`, params);
  },

  getPublicEventCached(id, params) {
    return apiService.getCached(`/public/events/${id}`, params);
  },

  createEvent(params) {
    return apiService.post('/events', params);
  },

  publishEvent(id, params) {
    return apiService.put(`/events/${id}/publish`, params);
  },

  updateEvent(id, params) {
    const hasSpecial = Object.keys(params).some((i) => EVENT_SPECIAL_PARAMS_FOR_UPDATE.includes(i));
    const url = `/events/${id}${hasSpecial ? '/edit' : ''}`;
    return apiService.put(url, params);
  },

  deleteEvent(id) {
    return apiService.delete(`/events/${id}`);
  },

  showPublicEvent(id, params) {
    return apiService.get(`/public/events/${id}`, params);
  },

  getPublicEventNominations(id, params) {
    return apiService.get(`/public/events/${id}/nominations`, params);
  },

  showEvent(id, params) {
    return apiService.get(`/events/${id}`, params);
  },

  closeEvent(id, payload) {
    return apiService.put(`/events/${id}/close`, payload);
  },

  massCloseEvents(payload) {
    return apiService.put('/events/mass-close', payload);
  },

  cloneEvent(id, payload) {
    return apiService.put(`/events/${id}/clone`, payload);
  },

  getEventOptions(params) {
    return apiService.get('/event-options/', params);
  },

  showEventOptions(id, params) {
    return apiService.get(`/event-options/${id}`, params);
  },

  showPublicEventOptions(params) {
    return apiService.get('/public/event-options/', params);
  },

  showPublicEventOption(id, params) {
    return apiService.get(`/public/event-options/${id}`, params);
  },

  createEventOptions(params) {
    return apiService.post('/event-options', params);
  },

  updateEventOptions(id, payload) {
    return apiService.put(`/event-options/${id}`, payload);
  },

  checkEventDuplicate(id) {
    return apiService.get(`/events/${id}/check-duplicate`);
  },

  // EVENT areas (места проведения мероприятия)

  createEventArea(payload) {
    return apiService.post('/event-areas', payload);
  },

  updateEventArea(id, payload) {
    return apiService.put(`/event-areas/${id}`, payload);
  },

  getEventAreas(params) {
    return apiService.get('/event-areas', params);
  },

  // EVENT groups

  createEventGroup(payload) {
    return apiService.post('/event-groups', payload);
  },

  updateEventGroup(id, payload) {
    return apiService.put(`/event-groups/${id}`, payload);
  },

  deleteEventGroup(id) {
    return apiService.delete(`/event-groups/${id}`);
  },

  getEventGroups(params) {
    return apiService.get('/event-groups', params);
  },

  getEventGroupsCached(params) {
    return apiService.getCached('/event-groups', params);
  },

  // EVENT groups ages

  createEventGroupAges(payload) {
    return apiService.post('/event-group-ages', payload);
  },

  updateEventGroupAges(id, payload) {
    return apiService.put(`/event-group-ages/${id}`, payload);
  },

  deleteEventGroupAges(id) {
    return apiService.delete(`/event-group-ages/${id}`);
  },

  getEventGroupsAges(params) {
    return apiService.get('/event-group-ages', params);
  },

  // EVENT categories

  getEventCategories(params) {
    return apiService.get('/event-categories', params);
  },

  getEventCategory(id) {
    return apiService.get(`/event-categories/${id}`);
  },

  // EVENT documents

  getPublicEventDocuments(params) {
    return apiService.get('/public/event-documents/', params);
  },

  getEventDocuments(params) {
    return apiService.get('/event-documents/', params);
  },

  createEventDocument(params) {
    return apiService.post('/event-documents/', params);
  },

  deleteEventDocument(id) {
    return apiService.delete(`/event-documents/${id}`);
  },

  // EVENT images

  getImages(params) {
    return apiService.get('/public/event-images', params);
  },

  createImage(params) {
    return apiService.post('/event-images', params);
  },

  updateImage(id, params) {
    return apiService.put(`/event-images/${id}/main`, params);
  },

  deleteImage(id) {
    return apiService.delete(`/event-images/${id}`);
  },

  // EVENT AWARDS

  getPublicAwards(params) {
    return apiService.get('/public/event-awards', params);
  },

  getAwards(params) {
    return apiService.get('/event-awards', params);
  },

  createAward(params) {
    return apiService.post('/event-awards', params);
  },

  deleteAward(id) {
    return apiService.delete(`/event-awards/${id}`);
  },

  updateAward(id, params) {
    return apiService.put(`/event-awards/${id}`, params);
  },

  // EVENT STAGES

  getPublicEventStages(params) {
    return apiService.get('/public/event-stages', params);
  },

  getStages(params) {
    return apiService.get('/event-stages', params);
  },

  getEventStagesCached(params) {
    return apiService.getCached('/event-stages', params);
  },

  createStage(params) {
    return apiService.post('/event-stages', params);
  },

  updateStage(id, params) {
    return apiService.put(`/event-stages/${id}`, params);
  },

  deleteStage(id) {
    return apiService.delete(`/event-stages/${id}`);
  },

  // certificate
  registerCertificate(id, params) {
    return apiService.post(`/events/${id}/register`, params);
  },

  // getSubordinationList(id, params) {
  //   return apiService.get(`/events/${id}/subordination-register`, params);
  // },

  unregisterCertificate(id, params) {
    return apiService.post(`/events/${id}/unregister`, params);
  },

  rejectCertificate(params) {
    return apiService.post('/events/reject', params);
  },

  getFavoriteEvents(params) {
    return apiService.get('/events/favorites', params);
  },

  addFavoriteEvents(params) {
    return apiService.post('/events/favorites/add', params);
  },

  deleteFavoriteEvents(params) {
    return apiService.post('/events/favorites/remove', params);
  },
  getAgreementText(id, params) {
    return apiService.post(`/events/${id}/agreement-text`, params);
  },

  // event members

  getPublicEventMembers(id, params) {
    return apiService.get(`/public/events/${id}/members`, params);
  },

  getEventMembers(id, params) {
    return apiService.get(`/events/${id}/members`, params);
  },

  rejectMember(id, params) {
    return apiService.post(`/events/${id}/members/reject`, params);
  },

  excludeMember(id, params) {
    return apiService.post(`/events/${id}/members/exclude`, params);
  },

  confirmMember(id, params) {
    return apiService.post(`/events/${id}/members/confirm`, params);
  },

  confirmAllMembers(id, params) {
    return apiService.post(`/events/${id}/members/confirm-all`, params);
  },

  considerMember(id, params) {
    return apiService.post(`/events/${id}/members/consider`, params);
  },
  replaceStageMembers(id, params) {
    return apiService.put(`/event-stages/${id}/replace-users`, params);
  },

  incorrectDocumentsMember(id, params) {
    return apiService.post(`/events/${id}/members/incorrect-documents`, params);
  },

  updateUserProfileByOrganizer(id, userId, payload) {
    return apiService.put(`/events/${id}/members/${userId}/profile`, payload);
  },

  // import members
  getImports(params) {
    return apiService.get('/import', params);
  },
  getImportById(id, params) {
    return apiService.get(`/import/by-id/${id}`, params);
  },

  createExtendImportRequest(eventId, nominationId, params) {
    return apiService.get(`import/events/${eventId}/nominations/${nominationId}/members-template`, params);
  },
  getListRequestsImport(params) {
    return apiService.get('exports/import-templates', params);
  },
  getImportList(params) {
    return apiService.get('event-global-attributes/import-template', params);
  },
  getUserInfoRequest(params) {
    return apiService.get('user-event-info-requests', params);
  },
  postImportList(params) {
    return apiService.post('user-event-info-requests', params);
  },
  postUserInfoRequestMassStore(params) {
    return apiService.post('user-event-info-requests/mass-store', params);
  },
  deleteLogRequestImport(id) {
    return apiService.delete(`exports/${id}`);
  },
  getListExportTypes(params) {
    return apiService.get('lists/export-types', params);
  },
  importMembersFromTable(params) {
    return apiService.post('/import/members', params);
  },
  importMembers(id, params) {
    return apiService.post(`events/${id}/members/import`, params);
  },
  getImportedData({ event_id, nomination_id, params }) {
    return apiService.get(`/import-data/members/event/${event_id}/nomination/${nomination_id}`, params);
  },
  updateImportedDataParticipant(id, params) {
    return apiService.put(`/import-data/members/${id}`, params);
  },
  deleteImportedDataParticipant(id) {
    return apiService.delete(`/import-data/members/${id}`);
  },
  deleteImportedDataParticipants({ event_id, nomination_id, params }) {
    return apiService.delete(`/import-data/members/event/${event_id}/nomination/${nomination_id}`, params);
  },
  saveImportedData({ event_id, nomination_id, params }) {
    return apiService.post(`/import-data/members/event/${event_id}/nomination/${nomination_id}`, params);
  },
  importDataInvitesGet(id, params) {
    return apiService.post(`/import-data/invites/get/${id}`, params);
  },
  importDataInvitesGenerate(id, params) {
    return apiService.post(`/import-data/invites/generate/${id}`, params);
  },
  importDataInvitesInfo(params) {
    return apiService.post(`/import-data/invites/info`, params);
  },
  importDataInvitesMerge(params) {
    return apiService.post(`/import-data/invites/merge`, params);
  },

  // event users

  getEventUsers(id, params) {
    return apiService.get(`/event-users/${id}`, params);
  },

  // EVENT REPORTS

  getReports(params) {
    return apiService.get('/exports', params);
  },
  getReportsTypes(params) {
    return apiService.get('/lists/export-types', params);
  },
  createReport(id, params) {
    return apiService.post(`/exports/make/${id}`, params);
  },
  createReportAnalytic(id, params) {
    return apiService.post(`/exports/make-analytic/${id}`, params);
  },
  removeReports(id, params) {
    return apiService.delete(`/exports/${id}`, params);
  },

  // SIGNFICANT

  significantEvents(params) {
    return apiService.get('/public/events/significant', params);
  },

  significantEventStages(params) {
    return apiService.get('/public/event-stages/significant', params);
  },
  // Significance EVENTS
  getOperatorSignificantEvents(params) {
    return apiService.get('/event-significances', params);
  },

  createOperatorSignificantEvents(params) {
    return apiService.post('/event-significances', params);
  },

  updateOperatorSignificantEvents(id, params) {
    return apiService.put(`/event-significances/${id}`, params);
  },

  deleteOperatorSignificantEvents(id) {
    return apiService.delete(`/event-significances/${id}`);
  },

  // MODERATION
  confirmEvent(id, params) {
    return apiService.put(`/events/${id}/confirm`, params);
  },

  rejectEvent(id, params) {
    return apiService.put(`/events/${id}/refuse`, params);
  },

  // Attributes

  showEventAttributes(id, params) {
    return apiService.get(`/event-attributes/${id}`, params);
  },

  getEventAttributes(params) {
    return apiService.get('/event-attributes', params);
  },

  createEventAttributes(params) {
    return apiService.post('/event-attributes', params);
  },

  updataEventAttributes(id, params) {
    return apiService.put(`/event-attributes/${id}`, params);
  },

  deleteEventAttribute(id) {
    return apiService.delete(`/event-attributes/${id}`);
  },

  deleteAllEventAttributes(params) {
    return apiService.delete('/event-attributes/', { data: params });
  },

  getEventGlobalAttributes(id, params) {
    return apiService.get(`/events/${id}/attributes`, params);
  },

  eventHistoryModeration(id, params) {
    return apiService.get(`/events/${id}/history`, params);
  },

  getEventSubordinations(params) {
    return apiService.get('/event-subordinations', params);
  },

  getEventSubordinationUsers(id, params) {
    return apiService.get(`/events/${id}/subordination-users`, params);
  },

  confirmEventRegister(id, params) {
    return apiService.post(`/events/${id}/confirm-register`, params);
  },

  // участники детально относительно мероприятия с награжденными местами и передачей через субординацию со статусами
  getMembersByHigher(id, params) {
    return apiService.get(`/events/${id}/members/by-higher`, params);
  },

  // EVENT nominations

  createEventNomination(payload) {
    return apiService.post('/event-nominations', payload);
  },

  getEventNominations(params) {
    return apiService.get('/event-nominations', params);
  },

  getEventNominationsCached(params) {
    return apiService.getCached('/event-nominations', params);
  },

  deleteEventNomination(id) {
    return apiService.delete(`/event-nominations/${id}`);
  },

  getPublicNominations(params) {
    return apiService.get('public/event-nominations/', params);
  },

  getPublicNominationsCached(params) {
    return apiService.getCached('public/event-nominations/', params);
  },

  addEventNominationGroups(nomination_id, params) {
    return apiService.put(`/event-nominations/${nomination_id}/groups`, params);
  },

  deleteEventNominationGroups(nomination_id, params) {
    return apiService.delete(`/event-nominations/${nomination_id}/groups`, params);
  },

  expelUsers(id, params) {
    return apiService.post(`/events/${id}/members/expel`, params);
  },

  getEventAvailableNominations(id, params) {
    return apiService.get(`/events/${id}/available-nominations`, params);
  },

  // members export /events/3/members/export
  exportMembers(id, params) {
    return apiService.post(`/events/${id}/members/export`, params);
  },
  exportMembersRewards(id) {
    return apiService.post(`/events/${id}/members/export-rewards`);
  },
  // results

  getEventsResults(user_id, params) {
    return apiService.get(`results/users/${user_id}`, params);
  },

  getProgramProject(params) {
    return apiDirectoryService.get('/program-projects', params);
  },

  getCertificate(certificate_id, params) {
    return apiService.get(`/event-certificates/${certificate_id}`, params);
  },

  getCertificateNew(certificate_id, params) {
    return apiService.get(`/event-certificates/${certificate_id}/certificate`, params);
  },

  getCertificatePath(certificate_id, params) {
    return apiService.get(`/event-certificates/path/${certificate_id}`, params);
  },

  getCertificateCached(certificate_id, params) {
    return apiService.getCached(`/event-certificates/${certificate_id}`, params);
  },

  getCertificates(params) {
    return apiService.get('/event-certificates', params);
  },

  regenerateCertificates(eventId, params) {
    return apiService.put(`/event-certificates/regenerate/${eventId}`, params);
  },

  // User Requirements

  getUserRequirements(params) {
    return apiService.get('/event-user-requirements', params);
  },

  /**
   *  payload: {
   *    event_id: number;
   *    event_nomination_id: number;
   *    is_municipality_required?: boolean;
   *    is_region_required?: boolean;
   *    is_first_name_required?: boolean;
   *    is_last_name_required?: boolean;
   *    is_birthday_at_required?: boolean;
   *    is_snils_required?: boolean;
   *  }
   */
  setUserRequirements(payload) {
    return apiService.post('/event-user-requirements', payload);
  },

  /**
   *  payload: {
   *    event_id: number;
   *    event_nomination_id: number;
   *    is_municipality_required?: boolean;
   *    is_region_required?: boolean;
   *    is_first_name_required?: boolean;
   *    is_last_name_required?: boolean;
   *    is_birthday_at_required?: boolean;
   *    is_snils_required?: boolean;
   *  }
   */
  changeUserRequirements(eventUserRequirementsId, payload) {
    return apiService.put(`/event-user-requirements/${eventUserRequirementsId}`, payload);
  },

  /**
   *  payload: {
   *    event_id: number;
   *    event_nomination_id: number;
   *  }
   */
  deleteUserRequirements(eventUserRequirementsId, payload) {
    return apiService.delete(`/event-user-requirements/${eventUserRequirementsId}`, payload);
  },

  /**
   *  payload: {
   *    event_id: number;
   *    nomination_ids: number[];
   *  }
   */
  checkUserRequirements(payload) {
    return apiService.post('/event-user-requirements/check', payload);
  },

  // organizers steps
  getOrganizersStep(params) {
    return apiService.get('/event-steps', params);
  },

  addOrganizersStep(eventId, params) {
    return apiService.put(`/event-steps/${eventId}`, params);
  },

  // quota
  setGlobalQuota(params) {
    return apiService.post('/quotas/default', params);
  },

  // EVENT directory documents

  getEventDirectoryDocuments(id, params) {
    return apiService.get(`/event-directory-documents/${id}`, params);
  },

  addEventDirectoryDocuments(id, params) {
    return apiService.post(`/event-directory-documents/${id}/add`, params);
  },

  addEventNoDirectoryDocument(documentId, params) {
    return apiService.post(`/event-directory-document/${documentId}/upload`, params);
  },

  removeEventDirectoryDocuments(id, params) {
    return apiService.delete(`/event-directory-documents/${id}/remove`, { params });
  },

  changeWeightEventDirectoryDocuments(id, document_id, params) {
    return apiService.put(`/event-directory-documents/${id}/weight/${document_id}`, { params });
  },

  getEventDirectoryDocumentsOptions(params) {
    return apiService.get('/event-directory-document-options', params);
  },

  createEventDirectoryDocuments(params) {
    return apiService.post('/event-directory-document-options', params);
  },

  updateEventDirectoryDocuments(id, params) {
    return apiService.put(`/event-directory-document-options/${id}`, params);
  },

  deleteEventDirectoryDocuments(id) {
    return apiService.delete(`/event-directory-document-options/${id}`);
  },

  deleteAllEventDirectoryDocumentsOptions(params) {
    return apiService.delete(`/event-directory-document-options/`, { params });
  },

  getNewEventDirectoryDocuments(id, params) {
    return apiService.get(`/events/${id}/documents`, params);
  },

  // EVENT documents
  getDocuments(params) {
    return apiService.get('/event-document-templates', params);
  },
  uploadDocument(params) {
    return apiService.post('/event-document-templates', params);
  },
  deleteDocument(id) {
    return apiService.delete(`/event-document-templates/${id}`);
  },

  saveNominationsDocuments(id, params) {
    return apiService.put(`/events/${id}/document-nominations`, params);
  },

  getDocumentsAgreements(params) {
    return apiService.get('/event-document-agreements', params);
  },
  createDocumentsAgreements(params) {
    return apiService.post('/event-document-agreements', params);
  },
  deleteDocumentsAgreements(id) {
    return apiService.delete(`/event-document-agreements/${id}`);
  },
  updateDocumentsAgreements(id, params) {
    return apiService.put(`/event-document-agreements/${id}`, params);
  },

  // EVENT form
  getEventForm(id, params) {
    return apiService.get(`/event-form/${id}`, params);
  },

  getEventFormMember(id, memberId, params) {
    return apiService.get(`/event-form/${id}/${memberId}`, params);
  },

  getEventFormMemberCached(id, memberId, params) {
    return apiService.getCached(`/event-form/${id}/${memberId}`, params);
  },

  // Certificate
  getCertificateSettings(eventId, params) {
    return apiService.get(`/events/${eventId}/certificate-settings`, params);
  },
  getOrganizerLogos(organizerId, params) {
    return apiService.get(`/organizers/${organizerId}/logos`, params);
  },
  updateOrganizerLogo(organizerId, logoId, params) {
    return apiService.put(`/organizers/${organizerId}/logos/${logoId}`, params);
  },
  getMainOrganizerLogos(eventId, params) {
    return apiService.get(`events/${eventId}/main-organizer-logos`, params);
  },
  removeLogo(organizerId, logoId, params) {
    return apiService.delete(`/organizers/${organizerId}/logos/${logoId}`, params);
  },
  addOrganizerLogos(organizerId, params) {
    return apiService.post(`/organizers/${organizerId}/logos`, params);
  },
  editDemoCertificate(params) {
    return apiService.post(`/organizers/demo-certificate`, params);
  },
  getDemoCertificate(organizerId, params) {
    return apiService.post(`/organizers/demo-certificate/`, params);
  },
  updateCertificateSettings(eventId, certificateId, payload) {
    return apiService.put(`/events/${eventId}/certificate-settings/${certificateId}`, payload);
  },
  resetCertificateSettings(eventId, certificateId, payload) {
    return apiService.post(`/events/${eventId}/certificate-settings/${certificateId}/reset`, payload);
  },
  addCertificatePlate(payload) {
    return apiService.post('/certificate-settings/certificate-plates', payload);
  },
  getCertificatePlates(params) {
    return apiService.get('/certificate-settings/certificate-plates', params);
  },
  removeCertificatePlate(id) {
    return apiService.delete(`/certificate-settings/certificate-plates/${id}`);
  },
  updateOrientation(eventId, params) {
    return apiService.post(`events/${eventId}/active-certificate-setting`, params);
  },
  getOrientation(eventId, params) {
    return apiService.get(`events/${eventId}/active-certificate-setting`, params);
  },
  checkUserInfoCompleted(eventId, params) {
    return apiService.get(`events/${eventId}/has-user-info`, params);
  },

  // Monitoring
  createReadyReport(params) {
    return apiService.post('/event-ready', params);
  },

  getReadyReports(params) {
    return apiService.get('/event-ready', params);
  },

  getReadyReport(id, params) {
    return apiService.get(`/event-ready/${id}`, params);
  },

  deleteReadyReport(reportId, params) {
    return apiService.delete(`/event-ready/${reportId}`, params);
  },

  // ADMIN

  adminGetEvents(params) {
    return apiService.get('/admin/events', params);
  },

  adminShowEvent(id, params) {
    return apiService.get(`/admin/events/${id}`, params);
  },

  adminEditEvent(id, params) {
    return apiService.put(`/admin/events/${id}`, params);
  },

  adminDeleteEvent(id) {
    return apiService.delete(`/admin/events/${id}`);
  },

  adminGetEventStages(params) {
    return apiService.get('/admin/event-stages', params);
  },

  adminGetEventOptions(id, params) {
    return apiService.get(`/admin/events/${id}/options`, params);
  },

  adminEditEventOptions(id, params) {
    return apiService.put(`/admin/events/${id}/options`, params);
  },

  adminGetEventMembers(id, params) {
    return apiService.get(`/admin/events/${id}/members`, params);
  },

  adminEventMembersMove(id, params) {
    return apiService.post(`/admin/events/${id}/members/transfer`, params);
  },

  adminPollRecalculate(params) {
    return apiService.post('/admin/polls/recalculate', params);
  },

  adminGetEventAreas(params) {
    return apiService.get('admin/events/areas', params);
  },

  adminEditEventArea(id, params) {
    return apiService.put(`admin/events/areas/${id}`, params);
  },

  adminConfirmEvent(id) {
    return apiService.put(`/admin/events/${id}/confirm`);
  },

  adminRejectEvent(id) {
    return apiService.put(`/admin/events/${id}/refuse`);
  },

  // PARTNERTS

  createPartner(params) {
    return apiService.post('/event-partners', params);
  },

  getPartner(id, params) {
    return apiService.get(`/event-partners/${id}`, params);
  },

  getPartners(params) {
    return apiService.get('/event-partners/', params);
  },

  getPublicPartners(params) {
    return apiService.get('/public/event-partners/', params);
  },

  updatePartner(id, params) {
    return apiService.put(`/event-partners/${id}`, params);
  },

  deletePartner(id) {
    return apiService.delete(`/event-partners/${id}`);
  },

  // PFDO-EXPORTS

  getPfdoExportsEvents(params) {
    return apiService.get('/pfdo-exports/events', params);
  },

  getPfdoExportsUsers(params) {
    return apiService.get('/pfdo-exports/users', params);
  },

  // ACTIVITIES

  getEventActivities(eventId, params) {
    return apiService.get(`/events/${eventId}/activities`, params);
  },

  getEventActivitiesPublic(eventId, params) {
    return apiService.get(`/public/events/${eventId}/activities`, params);
  },

  // AWARD SETTINGS

  getAwardSettings(eventId, params) {
    return apiService.get(`/events/${eventId}/award-settings`, params);
  },

  getFillingScore(eventId, params) {
    return apiService.get(`/events/${eventId}/filling-score`, params);
  },
};
